import { createApp } from "vue";
import { createWebHistory, createRouter } from "vue-router";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faHome,
  faSpinner,
  faUpload,
  faImage,
  faText,
  faSave,
  faLongArrowLeft,
  faArrowToLeft,
  faArrowToRight,
  faBorderCenterV,
  faBringFront,
  faLock,
  faUnlockAlt,
  faClone,
  faTrashAlt,
  faIntersection,
  faUnion,
  faUndo,
  faRedo,
  faChevronRight
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import App from "./App.vue";
import HomePage from "./pages/Home.vue";
import store from "./store";
import googlefonts from "./plugins/googlefonts";
import "./index.scss";
import "./fonts.css";

library.add(
  faHome,
  faSpinner,
  faUpload,
  faImage,
  faText,
  faSave,
  faLongArrowLeft,
  faArrowToLeft,
  faArrowToRight,
  faBorderCenterV,
  faBringFront,
  faLock,
  faUnlockAlt,
  faClone,
  faTrashAlt,
  faIntersection,
  faUnion,
  faUndo,
  faRedo,
  faChevronRight
);

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      component: () => import("./pages/Home.vue"),
    },
  ],
});

createApp(App)
  .use(googlefonts)
  .use(store)
  .use(router)
  .component("fa", FontAwesomeIcon)
  .mount("#app");
